import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPromotionsGrowth2024PopupTrialStartedComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('billing') declare billingService: Service.Billing;

	@service('flow/promotions')
	declare flowPromotionsService: Service.Flow.Promotions;

	get promotion() {
		return this.flowPromotionsService.promotions.growthPlanDiscountOptionPromotion;
	}

	get showYearlyOption() {
		return !this.billingService.activePlan?.isYearly && this.billingService.yearlySavings > 0; // isPayingCustomer is a given
	}

	get hasUserSeenTrialFeaturesPromo() {
		return this.flowPromotionsService.hasSeenGrowth2024PopupTrialStarted;
	}

	@action
	openGrowthPromoUpgradePopup() {
		this.flowPromotionsService.openGrowthPromoUpgradePopup('promote_growth_plan_popup');
	}
	<template>
		<div class="content">
			<img
				class="promo-image"
				src="/images/billing/promotions/growth-2024.png"
				alt="Upgrade promo"
			/>

			<h4>LIMITED OFFER</h4>

			<h3>Upgrade now and save {{this.promotion.totalDiscountAmmountFormatted}}</h3>

			{{#if this.hasUserSeenTrialFeaturesPromo}}
				<p>
					You've experienced the benefits of the Growth plan—now make them yours forever.
				</p>
			{{/if}}

			<p>
				Upgrade to
				<b>Growth plan by {{this.promotion.formattedActiveUntilMMMDo}}</b>
				to enjoy:
				<ul>
					<li>
						<span class="size">
							A
							{{this.promotion.discountAmmountFormatted}}
							monthly discount for the first
							{{this.promotion.discountDurationInMonths}}
							months
						</span>
					</li>
					{{#if this.showYearlyOption}}
						<li>
							<span class="size">
								<b>
									Additional
									{{this.billingService.billingCycleDiscounts.yearly}}% off
								</b>
								for
								<b>{{this.billingService.formattedYearlySavings}}</b>
								savings when you switch to a yearly subscription
							</span>
						</li>
					{{/if}}
				</ul>
			</p>

			<p>
				<b>
					Don’t miss out. Upgrade by
					{{this.promotion.formattedActiveUntilMMMDo}}
					and get
					{{this.promotion.totalDiscountAmmountFormatted}}
					off.
				</b>
			</p>

			<div class="footer">
				<a
					role="button"
					class="button size-big"
					{{on "click" this.openGrowthPromoUpgradePopup}}
				>
					Claim offer
				</a>
			</div>
		</div>
	</template>
}
